const MOBILE = /Mobile|Android/.test(navigator.userAgent);

export const onlineText = `
[${MOBILE ?
	'How many times have you checked your phone today?'
	: 'How much time have you spent mindlessly browsing today?'
}]

If you came across this page, chances are you aren’t very productive or focused right now. 😄 No worries; we’re going to help you reset your attention and focus.

It will take you less than two minutes, and all you need to do now is
[${MOBILE ?
	'enable airplane mode.'
	: 'switch off your WiFi connection.'
}]

The next page will load once you have done that.
`;

export const offlineText = `
What was it like to switch off? Did you feel anxious? Relieved?

Instead of treating technology as a useful tool, we became slaves to it. We check our devices between every 4 to 11 minutes. 60% of all work interruptions involve emails, social media, texts, etc. One third of us would rather give up sex than their smartphones. And yet, we are afraid of missing out.

Has something gone wrong here? Big tech companies want us to stay online as much as they can keep us. This is how they make money.

Do you often feel that you don’t have enough time to do things you love? Would you like to spend more time with your family, travel, sleep more, or learn a new language? Here’s where your time goes: on managing digital distractions and feeding the growth of tech giants.

Like with food, we need time not only to consume information, but also to digest it. To be productive, think outside of the box and have better, deeper relationships with people around us, we need to have periods of silence and uninterrupted attention.

Technology can be a useful tool, but only when we manage it, as opposed to allowing it to manage us.

Here’s how to claim back your life. While you are still offline, think of one thing that will make a huge difference to your life and happiness you could do this week? Write this thing down and attach to your monitor or your phone. Now go and do it, without losing any more time on digital procrastination.
`;

export const offlineClosing = `
If this message resonated with you, please support our [crowdfunding campaign for Homo Distractus].
`;

export const specials = {
	'crowdfunding campaign for Homo Distractus': {
		type: 'link',
		shortName: 'crowdfunding',
		longName: 'the Homo Distractus crowdfunding campaign',
		href: 'https://igg.me/at/homodistractus'
	},
};



// WEBPACK FOOTER //
// ./src/texts.js